module.exports = __webpack_public_path__ + "img/dialog-bg.08b4fc31.png";